export type ReleaseContract = Readonly<{
    protocolVersion: number;
    minSupportedFrontendProtocolVersion: number;
}>;

const assertPositiveInteger = (value: number, fieldName: keyof ReleaseContract): number => {
    if (!Number.isInteger(value) || value < 1) {
        throw new Error(`[release-contract] ${fieldName} must be a positive integer, received "${value}"`);
    }

    return value;
};

export const createReleaseContract = ({
    protocolVersion,
    minSupportedFrontendProtocolVersion,
}: ReleaseContract): ReleaseContract => {
    const resolvedProtocolVersion = assertPositiveInteger(protocolVersion, 'protocolVersion');
    const resolvedMinSupportedFrontendProtocolVersion = assertPositiveInteger(
        minSupportedFrontendProtocolVersion,
        'minSupportedFrontendProtocolVersion',
    );

    if (resolvedMinSupportedFrontendProtocolVersion > resolvedProtocolVersion) {
        throw new Error('[release-contract] minSupportedFrontendProtocolVersion cannot exceed protocolVersion');
    }

    return Object.freeze({
        protocolVersion: resolvedProtocolVersion,
        minSupportedFrontendProtocolVersion: resolvedMinSupportedFrontendProtocolVersion,
    });
};

export const releaseContract = createReleaseContract({
    protocolVersion: 13,
    minSupportedFrontendProtocolVersion: 13,
});
